/**
 * Slider Component
 *
 * @file lightbox.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
// import "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css";

const loadFancyboxCSS = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
  document.head.appendChild(link);
};

const lightbox = (() => {

  const homeLightbox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Fancybox ayarlarını buraya ekleyebilirsiniz
    });   
    Fancybox.bind('[data-fancybox="product-gallery"]', {
      // Fancybox ayarlarını buraya ekleyebilirsiniz
    });   
    loadFancyboxCSS(); 
  }

  const init = () => {
    homeLightbox();
  };

  return {
    init,
  };
})();

export default lightbox;
